import { TutorialVideoWindowComponent } from './../tutorial-video-window/tutorial-video-window.component';
import { Component, OnInit } from '@angular/core';
import { WorkspaceServiceService } from '../../services/workspace-service.service';

@Component({
  selector: 'mobile-tutorial-video-window',
  template: require('./mobile-tutorial-video-window.component.html'),
  styles: [require('./mobile-tutorial-video-window.component.css')]
})
export class MobileTutorialVideoWindowComponent{
  constructor(public workspaceService: WorkspaceServiceService) {  }

  public onVideoEnded(e:any){}
}
